<template>
  <router-view/>
</template>

<style lang="scss">
.main-sidebar {
  width: 260px;
}

body:not(.sidebar-mini-md):not(.sidebar-mini-xs):not(.layout-top-nav) .main-header {
  margin-left: 260px;
}
</style>
